import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

// ✅ Import directo del logo local
import cleanworkLogo from '@/assets/images/cleanwork-logo.png';

const links = [
  ['Inicio', '#inicio'],
  ['¿Quiénes somos?', '#nosotros'],
  ['Servicios', '#servicios'],
  ['Nuestro proceso', '#proceso'],
  ['¿Por qué elegirnos?', '#ventajas'],
  ['Contacto', '#cotizacion'],
];

const Header = () => {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  // Efecto para cambiar el fondo al hacer scroll
  useEffect(() => {
    const handleScroll = () => setSolid(window.scrollY > 40);
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Cerrar menú al hacer click en un enlace
  const handleLinkClick = () => setOpen(false);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid || open
          ? 'bg-white shadow-sm'
          : 'bg-gradient-to-b from-[#061a2c]/80 to-transparent'
      }`}
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
        {/* Logo */}
        <a href="#inicio" aria-label="Clean Work inicio">
          <img
            src={cleanworkLogo}
            alt="Clean Work Servicios de Limpieza"
            className="h-12 w-44 object-contain"
          />
        </a>

        {/* Navegación Desktop */}
        <nav className="hidden items-center gap-6 lg:flex">
          {links.map(([label, href]) => (
            <a
              key={href}
              href={href}
              className={`text-sm font-semibold transition hover:text-emerald-500 ${
                solid ? 'text-[#0A2540]' : 'text-white'
              }`}
            >
              {label}
            </a>
          ))}
          <a
            href="#cotizacion"
            className="rounded-sm px-5 py-3 text-xs font-bold tracking-wide text-white hover:bg-emerald-700 bg-[#94cf1c] transition-colors"
          >
            SOLICITAR COTIZACIÓN
          </a>
        </nav>

        {/* Botón menú móvil */}
        <button
          onClick={() => setOpen(!open)}
          className={`p-2 lg:hidden ${
            solid || open ? 'text-[#0A2540]' : 'text-white'
          }`}
          aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {/* Menú móvil desplegable */}
      {open && (
        <nav className="border-t bg-white px-5 py-5 lg:hidden">
          {links.map(([label, href]) => (
            <a
              key={href}
              href={href}
              onClick={handleLinkClick}
              className="block border-b py-3 font-semibold text-[#0A2540] hover:text-emerald-600 transition-colors"
            >
              {label}
            </a>
          ))}
          <a
            href="#cotizacion"
            onClick={handleLinkClick}
            className="mt-5 block bg-[#94cf1c] p-4 text-center font-bold text-white hover:bg-emerald-700 transition-colors"
          >
            SOLICITAR COTIZACIÓN
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;